import { commonFilter } from './filter';

export default function (path: string) {
  return {
    pageName: '',
    pageId: '20031',
    pagePath: path,
    common: {
      source: 2,
      typeId: 'opinion_pc_v2',
    },
    button: {
      ...commonFilter,
      Report_Tab: {
        buttonId: '2003101',
      },
    },
  };
}
